export const AUTH_FORGOT_PASSWORD_REQUEST = 'auth/forgot-password-request'
export const AUTH_FORGOT_PASSWORD_SUCCESS = 'auth/forgot-password-success'
export const AUTH_FORGOT_PASSWORD_FAILED = 'auth/forgot-password-failed'
